import { render } from "./IconBreathQuality.vue?vue&type=template&id=5cc08025"
import script from "./IconBreathQuality.vue?vue&type=script&lang=js"
export * from "./IconBreathQuality.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__